'use strict';

/**
 * View for empty contact lists
 *
 * @category   View
 * @module     community
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ItemView = require('base/Colido.ItemView');

var template = require('modules/community/templates/partials/groups-empty.hbs');

var EmptyView = ItemView.extend({
    template: template,

    tagName: 'li',

    className: 'empty-hint',

    viewData: {
        emptyMessage: function(){
            return this.getOption('type') === 'broadcast' ? 'community::broadcasts:empty' : 'community::groups:empty';
        },
    },
});

module.exports = EmptyView;